<template>
    <div class="container">
        <el-form ref="form" :model="pageData.personalForm" label-width="74px">
            <el-form-item label="姓名">
                <el-input v-model="pageData.personalForm.name"></el-input>
            </el-form-item>

            <el-form-item label="性别">
                <el-radio-group v-model="pageData.personalForm.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="民族">
                <el-input v-model="pageData.personalForm.ethnic"></el-input>
            </el-form-item>
            <el-form-item label="出生日期">
                <el-date-picker v-model="pageData.personalForm.birthDate" type="date" style="width: 100%"
                    placeholder="选择日期" format="YYYY/MM/DD" value-format="YYYY-MM-DD">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="国家/地区">
                <div class="selectFourWap">
                    <div>
                        <el-input v-model="pageData.personalForm.nation" placeholder="国家"></el-input>
                    </div>
                    <div>
                        <el-input v-model="pageData.personalForm.province" placeholder="省"></el-input>
                    </div>
                    <div>
                        <el-input v-model="pageData.personalForm.city" placeholder="市"></el-input>
                    </div>
                    <div>
                        <el-input v-model="pageData.personalForm.district" placeholder="区"></el-input>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="具体地址">
                <el-input v-model="pageData.personalForm.address"></el-input>
            </el-form-item>
            <el-form-item label="证件类型">
                <div class="formBody">
                    <el-select v-model="pageData.personalForm.cardType" placeholder="证件类型">
                        <el-option label="居民身份证" value="1"></el-option>
                        <el-option label="营业执照" value="3"></el-option>
                        <el-option label="居住证" value="4"></el-option>
                        <el-option label="护照" value="9"></el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="证件号">
                <el-input v-model="pageData.personalForm.idNumber" @blur="onInputBlur"></el-input>
            </el-form-item>
            <el-form-item label="证件签发日期">
                <el-date-picker v-model="pageData.personalForm.issueDate" type="date" style="width: 100%"
                    format="YYYY/MM/DD" value-format="YYYY-MM-DD"></el-date-picker>
            </el-form-item>
            <el-form-item label="证件失效日期">
                <div class="expiryDateWap">
                    <div>
                        <el-radio-group v-model="pageData.cardEndTimtType"
                            @change="radioSetting(pageData.cardEndTimtType)">
                            <el-radio label="1">永久</el-radio>
                            <el-radio label="2">有效期</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-if="pageData.cardEndTimtType == '2'">
                        <el-date-picker v-model="pageData.personalForm.expirationDate" type="date" style="width: 100%"
                            format="YYYY/MM/DD" value-format="YYYY-MM-DD">
                        </el-date-picker>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="身份证照片">
                <div class="idCardWap">
                    <div class="item">
                        <div class="img_" v-if="pageData.cardHoldImage">
                            <input type="file" accept="image/*" @change="inputFile($event, 'cardHoldImage')" />
                            <img :src="pageData.cardHoldImage" alt="" />
                        </div>
                        <div class="img_" v-else>
                            <input type="file" accept="image/*" @change="inputFile($event, 'cardHoldImage')" />
                            <img src="@/assets/images/idCardType1.png" />
                        </div>
                    </div>
                    <div class="item">
                        <div class="img_" v-if="pageData.cardFrontImage">
                            <input type="file" accept="image/*" @change="inputFile($event, 'cardFrontImage')" />
                            <img :src="pageData.cardFrontImage" alt="" />
                        </div>
                        <div class="img_" v-else>
                            <input type="file" accept="image/*" @change="inputFile($event, 'cardFrontImage')" />
                            <img src="@/assets/images/idCardType2.png" />
                        </div>
                    </div>
                    <div class="item">
                        <div class="img_" v-if="pageData.cardBackImage">
                            <input type="file" accept="image/*" @change="inputFile($event, 'cardBackImage')"
                                value-format="yyyy-MM-dd HH:mm:ss" />
                            <img :src="pageData.cardBackImage" alt="" />
                        </div>
                        <div class="img_" v-else>
                            <input type="file" accept="image/*" @change="inputFile($event, 'cardBackImage')"
                                value-format="yyyy-MM-dd HH:mm:ss" />
                            <img src="@/assets/images/idCardType3.png" />
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="pageData.personalForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="密码">
                <el-input v-model="pageData.personalForm.password" type="password"></el-input>
            </el-form-item>
        </el-form>
        <div class="formBodySet">
            <div class="pushAuthor" @click="addAuthorPersonalFun">保存</div>
            <div class="pushAuthor" style="background: #cc3f1f" @click="dataChange()">
                删除
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";
import { reactive } from "vue";
import {
    addAuthorPersonal,
} from "../../api/interfaceList.js";
export default {
    name: "container",
    setup(props, { emit }) {
        let pageData = reactive({
            cardEndTimtType: "1",
            formData: new FormData(),
            personalForm: {
                name: "",
                sex: "1",
                ethnic: "",
                birthDate: "",
                nation: "",
                province: "",
                city: "",
                district: "",
                address: "",
                idNumber: "",
                issueDate: "",
                cardType: "1",
                expirationDate: "2300-01-01",
                channel: "ly",
                phone: '',
                password: ''
            },
            cardHoldImage: "",
            cardFrontImage: "",
            cardBackImage: "",
        })
        function radioSetting(e) {
            let myDate = new Date((new Date).getTime() + 8 * 60 * 60 * 1000)
            let time = myDate.toJSON().split('T').join(' ').substr(0, 19)
            e == 1 ? pageData.personalForm.expirationDate = "2300-01-01" : pageData.personalForm.expirationDate = time.slice(0, time.length - 9)
        }
        function addAuthorPersonalFun() {
            for (var key in pageData.personalForm) {
                pageData.formData.append(key, pageData.personalForm[key]);
            }
            pageData.formData.append('worksCode', Cookies.get("contentUniqueCode"))
            addAuthorPersonal(pageData.formData).then(res => {
                pageData.formData = new FormData
                pageData.cardHoldImage = ""
                pageData.cardFrontImage = ""
                pageData.cardBackImage = ""
                if (res.code == 1) {
                    let json = {
                        data: {},
                        dataChangeShow: false
                    }
                    json.data = res.data
                    ElMessage({
                        message: res.message,
                        type: "success",
                    })
                    emit('dataChange', json)
                }else if(res.code == '-1001') {
                    ElMessage({
                        message: res.data[0].message,
                        type: "warning",
                    });
                } else {
                    ElMessage({
                        message: res.message,
                        type: "warning",
                    });
                }
            })
        }

        function dataChange() {
            let json = {
                data:'',
                dataChangeShow: false
            }
            emit('dataChange', json)
        }

        function inputFile(e, type) {
            let files = e.target.files[0];
            if (!files.type.match(/.jpg|.png|.jpeg/i)) {
                alert("图片格式错误,请上传png/jpg/jpeg格式的图片!");
                return;
            }
            if (type == "cardHoldImage") {
                pageData.formData.append("cardHoldImage", files); //添加Fail类型的图片信息的参数
            } else if (type == "cardFrontImage") {
                pageData.formData.append("cardFrontImage", files); //添加Fail类型的图片信息的参数
            } else if (type == "cardBackImage") {
                pageData.formData.append("cardBackImage", files); //添加Fail类型的图片信息的参数
            }
            var reader = new FileReader();
            reader.readAsDataURL(files);
            reader.onload = () => {
                if (type == "cardHoldImage") {
                    pageData.cardHoldImage = reader.result;
                } else if (type == "cardFrontImage") {
                    pageData.cardFrontImage = reader.result;
                } else if (type == "cardBackImage") {
                    pageData.cardBackImage = reader.result;
                }
            };
            reader.onerror = function () {
            };
        }
        return {
            pageData,
            radioSetting,
            inputFile,
            addAuthorPersonalFun,
            dataChange
        }
    }
}
</script>
<style lang="scss" scope>
.container {
    width: 550px;
    padding-bottom: 100px;
    box-sizing: border-box;

    .idCardWap {
        width: 452px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item {
            width: 144px;
            height: 96px;

            .img_ {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                position: relative;
                justify-content: center;

                input {
                    width: 100%;
                    height: 100%;
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 1;
                    opacity: 0;
                }

                img {
                    height: 100%;
                    width: auto !important;
                    //   position: absolute;
                    //   top: 0;
                    //   left: 0;
                }
            }
        }
    }

    .expiryDateWap {
        display: flex;
        justify-content: space-between;
        align-items: center;

        div:nth-of-type(1) {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        div:nth-of-type(2) {
            width: 250px;
        }
    }

    .selectFourWap {
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
            width: 100px;
        }
    }
}
</style>


